import clsx from 'clsx'

const LoadingSpinner = ({ fullScreen = false, message }) => {
  const spinner = (
    <div className="flex flex-col items-center gap-3">
      <div className="w-8 h-8 border-3 border-cb-accent/30 border-t-cb-accent rounded-full animate-spin" />
      {message && <p className="text-sm text-gray-500 font-medium">{message}</p>}
    </div>
  )

  if (fullScreen) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        {spinner}
      </div>
    )
  }

  return spinner
}

export default LoadingSpinner
